/**
 *  错误信息
 *
 *  此文件为自动生成，请不要修改！
 *
 *  生成日期: Tue Apr 01 11:33:04 CST 2025
 */

const getErrorMsg = (function () {
    let errorMsg = [];

    errorMsg["n-1"] = '系统异常，请稍后重试';  //UNKNOWN
    errorMsg["n0"] = 'success';  //SUCCESS
    errorMsg["n304"] = '系统异常，请稍后重试';  //NOT_MODIFIED
    errorMsg["n400"] = '系统异常，请稍后重试';  //BAD_REQUEST
    errorMsg["n401"] = '您当前状态已失效，请重新登录!';  //UNAUTHORIZED
    errorMsg["n403"] = '禁止访问';  //FORBIDDEN
    errorMsg["n404"] = 'Not Found';  //NOT_FOUND
    errorMsg["n405"] = '系统异常，请稍后重试';  //METHOD_NOT_ALLOWED
    errorMsg["n406"] = '系统异常，请稍后重试';  //NOT_ACCEPTABLE
    errorMsg["n407"] = '系统异常，请稍后重试';  //PROXY_AUTHENTICATION_REQUIRED
    errorMsg["n408"] = '系统异常，请稍后重试';  //REQUEST_TIMEOUT
    errorMsg["n412"] = '系统异常，请稍后重试';  //PRECONDITION_FAILED
    errorMsg["n413"] = '系统异常，请稍后重试';  //PAYLOAD_TOO_LARGE
    errorMsg["n415"] = '系统异常，请稍后重试';  //UNSUPPORTED_MEDIA_TYPE
    errorMsg["n417"] = '系统异常，请稍后重试';  //EXPECTATION_FAILED
    errorMsg["n422"] = '必须的参数未传入!';  //PARAM_BUILDING_ERROR
    errorMsg["n423"] = '系统异常，请稍后重试';  //LOCKED
    errorMsg["n424"] = '系统异常，请稍后重试';  //FAILED_DEPENDENCY
    errorMsg["n426"] = '系统异常，请稍后重试';  //UPGRADE_REQUIRED
    errorMsg["n429"] = '系统异常，请稍后重试';  //TOO_MANY_REQUESTS
    errorMsg["n500"] = '系统异常，请稍后重试!';  //INTERNAL_SERVER_ERROR
    errorMsg["n501"] = '系统异常，请稍后重试';  //NOT_IMPLEMENTED
    errorMsg["n503"] = '系统异常，请稍后重试';  //SERVICE_UNAVAILABLE
    errorMsg["n510"] = '系统异常，请稍后重试';  //NOT_EXTENDED
    errorMsg["n504"] = '网络连接超时，请稍后重试';  //GATEWAY_TIMEOUT
    errorMsg["n511"] = '系统异常，请稍后重试';  //NETWORK_AUTHENTICATION_REQUIRED
    errorMsg["n901"] = '系统异常，请稍后重试';  //UDR_INVALID_DATA
    errorMsg["n991"] = '系统异常，请稍后重试';  //DB_DATA_ACCESS
    errorMsg["n998"] = '系统异常，请稍后重试';  //DB_DATA_INTEGRITY_VIOLATION
    errorMsg["n999"] = '系统异常，请稍后重试';  //UNIQ_KEY_ERROR
    errorMsg["n1000"] = '系统错误,请联系管理员!';  //MAX_HARD_CODE
    errorMsg["n1001"] = '邮箱规格不存在';  //MA_NO_SPEC
    errorMsg["n1002"] = '邮箱账号或者列表已经存在';  //MA_ACCOUNT_EXIST
    errorMsg["n1003"] = '父部门不存在';  //MA_PARENT_DEPT_NOT_EXIST
    errorMsg["n1004"] = '有不存在的部门id';  //MA_DEPT_IDS_NOT_EXIST
    errorMsg["n1005"] = '父部门id不能设置成自己的子部门id';  //MA_PARENT_DEPT_NOT_PROMIT
    errorMsg["n1006"] = '存在子部门不允许删除';  //MA_DEL_DEPT_NOT_PROMIT
    errorMsg["n1007"] = '部门存在人员不允许删除';  //MA_DEL_DEPT_MEM_NOT_PROMIT
    errorMsg["n1008"] = '企业不存在此域名';  //MA_CORP_DOMAIN_NOT_EXIST
    errorMsg["n1009"] = '邮箱账号或者列表不存在';  //MA_ACCOUNT_NOT_EXIST
    errorMsg["n1010"] = '主邮箱账号不存在';  //MA_ACCOUNT_PRIME_NOT_EXIST
    errorMsg["n1011"] = '别名个数超出限制';  //MA_OVER_ALIAS_COUNT
    errorMsg["n1012"] = '别名不存在';  //MA_ALIAS_NOT_EXIST
    errorMsg["n1013"] = '通讯录不存在';  //MA_CONTACT_NOT_EXIST
    errorMsg["n1014"] = '父通讯录不存在';  //MA_PARENT_CONTACT_NOT_EXIST
    errorMsg["n1015"] = '存在子部门不允许删除';  //MA_DEL_CONTACT_NOT_PROMIT
    errorMsg["n1016"] = '存在通讯录信息不允许删除';  //MA_DEL_CONTACT_INFO_NOT_PROMIT
    errorMsg["n1017"] = '父通讯录id不能设置成自己的子通讯录id';  //MA_PARENT_CONTACT_NOT_PROMIT
    errorMsg["n1018"] = '企业不存在';  //MA_CORP_NOT_EXIST
    errorMsg["n1019"] = '企业id不存在';  //MA_CORP_ID_NOT_EXIST
    errorMsg["n1020"] = '邮箱规格不存在';  //MA_SPEC_NOT_EXIST
    errorMsg["n1021"] = '添加部门错误';  //MA_ADD_DEPART_ERROR
    errorMsg["n1022"] = '此规则不存在';  //MA_RULE_NOT_EXIST
    errorMsg["n1023"] = '部门id为空';  //MA_CORPID_DEPARTID_NULL
    errorMsg["n1024"] = '部门下存在用户不允许删除';  //MA_DEL_DEPART_USER_EXIST
    errorMsg["n1025"] = '用户名或密码错误';  //MA_USER_NOT_EXIST
    errorMsg["n1026"] = '登录时间限制参数不完整';  //MA_LOGIN_RULE_TIME_ERROR
    errorMsg["n1027"] = '登录限制规则不存在';  //MA_LOGIN_RULE_NOT_EXIST
    errorMsg["n1028"] = '登录限制规则已存在';  //MA_LOGIN_RULE_EXIST
    errorMsg["n1029"] = '邮箱规格关联了{}个企业，请先修改关联企业的邮箱规格。';  //MA_SPEC_BE_USED
    errorMsg["n1030"] = '黑白名单不存在';  //MA_BLACK_WHITE_LIST_NOT_EXIST
    errorMsg["n1031"] = '默认管理员权限组不允许修改';  //MA_PRIVILEGE_NOT_ALLOW_UPDATE
    errorMsg["n1032"] = '管理员权限组不存在';  //MA_PRIVILEGE_NOT_EXIST
    errorMsg["n1033"] = '企业域名已存在';  //MA_CORP_DOMAIN_EXIST
    errorMsg["n1034"] = '默认邮箱规则不允许删除';  //MA_SPEC_IS_DEFAULT
    errorMsg["n1035"] = '上传文件失败';  //MA_UPLOAD_FILE_FAIL
    errorMsg["n1036"] = '企业不存在主域名';  //MA_CORP_DOMAIN_NAME_NOT_EXIST
    errorMsg["n1037"] = '欢迎信已经存在，不能重复添加';  //MA_CORP_WELCOME_EMAIL_EXIST
    errorMsg["n1038"] = '欢迎信不存在';  //MA_CORP_WELCOME_EMAIL_NOT_EXIST
    errorMsg["n1039"] = '企业域名已经存在';  //MA_DOMAIN_ALREADY_EXIST
    errorMsg["n1040"] = 'API账号不存在';  //MA_API_NOT_EXIST
    errorMsg["n1041"] = '本企业API规则已经存在，不能重复添加';  //MA_API_EXIST
    errorMsg["n1042"] = '企业主域名已经存在';  //MA_MAIN_DOMAIN_ALREADY_EXIST
    errorMsg["n1043"] = '域名下还有用户存在';  //MA_DOMAIN_USER_EXIST
    errorMsg["n1044"] = '企业主域名不能删除';  //MA_MAIN_DOMAIN_NOT_DELETE
    errorMsg["n1045"] = '企业域名不存在';  //MA_DOMAIN_NOT_EXIST
    errorMsg["n1046"] = '企业默认域名不存在';  //MA_DEFAULT_DOMAIN_NOT_EXIST
    errorMsg["n1047"] = '邮箱规格名称重复';  //MA_SPEC_NAME_EXIST
    errorMsg["n1048"] = '邮箱规格有关联用户，不允许删除';  //MA_SPEC_USER_USED
    errorMsg["n1049"] = '系统账号不允许禁用或删除';  //MA_SYS_ACCOUNT_NOT_DELETE
    errorMsg["n1050"] = '邮箱规格最大空间不存在';  //MA_SPEC_MAX_SPACE_NOT_EXIST
    errorMsg["n1051"] = '新密码不能与原密码相同';  //MA_PASSWORD_SAME_ERROR
    errorMsg["n1052"] = '邮箱最大空间数过小';  //MA_MAX_SPACE_ERROR
    errorMsg["n1053"] = '企业人数超出最大限制，不允许添加用户';  //MA_CORP_USER_EXCEEDED_ERROR
    errorMsg["n1054"] = '默认管理员不允许编辑';  //MA_MANAGER_ADMIN_CANT_NOT_MODIFY
    errorMsg["n1055"] = '默认管理员不允许删除';  //MA_MANAGER_ADMIN_CANT_NOT_DELETE
    errorMsg["n1056"] = '没有权限操作此权限组';  //MA_NO_PERMISSION_MODIFY_PRIVILEGE
    errorMsg["n1057"] = '此权限组有关联用户，禁止删除';  //MA_PRIVILEGE_BE_USED
    errorMsg["n1058"] = '域名解析未验证成功，请核对解析记录';  //MA_DOMAIN_MX_VALIDATE_FAILED
    errorMsg["n1059"] = '批量任务Id不能为空';  //MA_TASK_ID_NOT_EXIST
    errorMsg["n1060"] = '企业视图不存在';  //MA_CORP_VIEW_NOT_EXIST
    errorMsg["n1061"] = '默认企业视图不允许删除';  //MA_CORP_VIEW_IS_DEF
    errorMsg["n1062"] = '视图成员不能为空';  //MA_CORP_VIEW_USER_IS_NULL
    errorMsg["n1063"] = '邮箱规格最大空间数过小';  //MA_SPEC_MAX_SPACE_ERROR
    errorMsg["n1064"] = '同一级下存在相同部门名';  //MA_DEPT_EXIST_SAME_NAME
    errorMsg["n1065"] = '入职日期格式不正确';  //MA_EXCEL_PARSE_ERROR
    errorMsg["n1067"] = '登录POP服务器失败';  //MA_POP_TEST_ERROR
    errorMsg["n1068"] = '登录IMAP服务器失败';  //MA_IMAP_TEST_ERROR
    errorMsg["n1069"] = '邮箱最大空间不能为空';  //MA_MAX_SPACE_IS_NULL
    errorMsg["n1070"] = '密码错误';  //MA_PWD_ERROR
    errorMsg["n1071"] = '管理员权限组名称已经存在';  //MA_PRIVILEGE_IS_EXIST
    errorMsg["n1072"] = '视图成员中存在非本企业域账号';  //MA_DOMAIN_IS_OTHERS
    errorMsg["n1073"] = '批量参数不能为空';  //MA_BATCH_PARAM_NOT_EMPTY
    errorMsg["n1074"] = '存在正在执行的批量任务，请稍后重试';  //MA_BATCH_TASK_LOCK_EXIST
    errorMsg["n1075"] = 'excel部门路径过长';  //MA_BATCH_DEPTPATH_TOOLONG
    errorMsg["n1076"] = '部门层级过多';  //MA_DEPT_OVER_DEEP
    errorMsg["n1077"] = '部门名称不合法';  //MA_DEPT_NAME_INVALID
    errorMsg["n1078"] = '必填用户邮箱不合法';  //MA_USER_EMAIL_INVALID
    errorMsg["n1079"] = '必填用户姓名不合法';  //MA_USER_NAME_INVALID
    errorMsg["n1080"] = '用户手机不合法';  //MA_USER_MOBILE_INVALID
    errorMsg["n1081"] = '用户座机不合法';  //MA_USER_TEL_INVALID
    errorMsg["n1082"] = '用户传真不合法';  //MA_USER_FAX_INVALID
    errorMsg["n1083"] = '用户备注不合法';  //MA_USER_MEMO_INVALID
    errorMsg["n1084"] = '用户员工编号不合法';  //MA_USER_EMPLOYEEID_INVALID
    errorMsg["n1085"] = '用户职位不合法';  //MA_USER_POSITION_INVALID
    errorMsg["n1086"] = '用户范围账号信息不能为空';  //MA_USER_SCOPE_ACCOUNT_CANNOT_EMPTY
    errorMsg["n1087"] = '不合法的模板类型';  //MA_INVALID_TEPMLATE_TYPE
    errorMsg["n1088"] = '邮箱规格填写错误';  //MA_BATCH_SPEC_ERROR
    errorMsg["n1089"] = 'excel文件中的数量超限';  //MA_BATCH_TASK_OVER_LIMIT
    errorMsg["n1090"] = '此地址已经存在黑名单';  //MA_BLACK_EXIST
    errorMsg["n1091"] = '定期修改密码周期必须大于0';  //MA_RULE_PWD_CYCLE
    errorMsg["n1092"] = '提醒周期不能大于或等于密码修改周期';  //MA_RULE_PWD_BEFORE
    errorMsg["n1093"] = '提醒频率不能大于或等于提醒周期';  //MA_RULE_PWD_REMIND
    errorMsg["n1094"] = 'API账号名称重复';  //MA_API_IS_EXIST
    errorMsg["n1095"] = '部门描述不合法';  //MA_DEPT_MEMO_INVALID
    errorMsg["n1096"] = '审核名称已经存在';  //MA_AUDIT_NAME_EXIST
    errorMsg["n1097"] = '分类过滤名称已经存在';  //MA_FILTER_NAME_EXIST
    errorMsg["n1098"] = '存在相同名称的规则';  //MA_RULE_SAME_NAME
    errorMsg["n1099"] = '存在相同名称的api';  //MA_API_SAME_NAME
    errorMsg["n1100"] = '部门不存在';  //MA_DEPT_NOT_EXIST
    errorMsg["n1101"] = '地址填写有误,不支持填写邮箱别名、辅域名';  //MA_MEMBER_CORRECT_ERROR
    errorMsg["n1102"] = '域名数量超过上限';  //MA_DOMAIN_COUNT_OVERFLOW
    errorMsg["n1103"] = '企业最大人数过小';  //MA_CORP_USER_NUM_SMALL
    errorMsg["n1104"] = '证书过期';  //MA_LICENSE_EXPIRED
    errorMsg["n1105"] = '不允许删除自己';  //MA_MANAGER_NOT_DELETE_SELF
    errorMsg["n1106"] = '不允许修改自己';  //MA_MANAGER_NOT_UPDATE_SELF
    errorMsg["n1107"] = '管理员已经存在';  //MA_PRIVILEGE_EXIST
    errorMsg["n1108"] = '禁止发送外域';  //MA_EXIST_FOREIGN_DOMAIN
    errorMsg["n1109"] = '嵌套列表存在死循环';  //MA_END_LESS_LOOP_LIST
    errorMsg["n1110"] = '嵌套列表不存在';  //MA_MAIL_LIST_NOT_EXIST
    errorMsg["n1111"] = '主域名信息不能为空';  //MA_MAIN_DOMAIN_NOT_NULL
    errorMsg["n1112"] = '审核人不存在';  //MA_AUDITOR_ERROR
    errorMsg["n1113"] = 'ms存审核索引报错';  //MA_AUDIT_MS_INDEX_ERROR
    errorMsg["n1114"] = '填写本企业下的主名邮箱地址';  //MA_CORP_MAIL_DEL_EMAIL_INVALID
    errorMsg["n1115"] = '视图范围仅支持填写本企业下的主名邮箱地址';  //MA_EMAIL_IS_OTHERS
    errorMsg["n1116"] = '审核原信解析失败';  //MA_AUDIT_MS_ERROR
    errorMsg["n1117"] = '审核人不存在';  //MA_AUDIT_AUDITOR_ERROR
    errorMsg["n1118"] = '审核原信解析失败';  //MA_AUDIT_MIME_ERROR
    errorMsg["n1119"] = '操作成功';  //MA_MANAGER_LOG_SUCCESS
    errorMsg["n1120"] = '操作失败';  //MA_MANAGER_LOG_ERROR
    errorMsg["n1121"] = '企业空间超出最大限制';  //MA_CORP_USER_SPACE_ERROR
    errorMsg["n1122"] = '管理员不能对自己进行操作，如果需要请联系上级管理员。';  //MA_CORP_MANAGER_NOT_DEL
    errorMsg["n1123"] = '根节点不允许删除';  //MA_TOP_NOT_DEL
    errorMsg["n1124"] = '收件人包含非本企业用户';  //MA_TO_FOREIGN_DOMAIN
    errorMsg["n1125"] = '此地址已经存在白名单';  //MA_WHITE_EXIST
    errorMsg["n1126"] = '视图名称重复';  //MA_CORP_VIEW_EXIST
    errorMsg["n1127"] = '企业人数超过授权人数，请重新输入或者联系超级管理员';  //MA_CORP_USER_LIMIT
    errorMsg["n1128"] = '邮箱状态错误';  //MA_MAIL_STATUS_ERROR
    errorMsg["n1129"] = 'IP格式错误';  //MA_IP_FORMAT_ERROR
    errorMsg["n1130"] = '用户id不能为空';  //MA_USER_ID_NULL
    errorMsg["n1131"] = '用户id不合法';  //MA_USER_ID_ERROR
    errorMsg["n1132"] = '账户到期执行动作错误';  //MA_EXPIRE_TYPE_ERROR
    errorMsg["n1133"] = '别名重复';  //MA_ALIAS_REPEAT_ERROR
    errorMsg["n1134"] = '外部联系人群组名称不能为空';  //MA_GROUP_NAME_NOT_NULL
    errorMsg["n1135"] = '外部联系人群组不存在';  //MA_GROUP_NOT_EXISTS
    errorMsg["n1136"] = '备份邮箱信息不存在';  //MA_BACKUP_MAIL_ACCOUNT_NOT_EXISTS
    errorMsg["n1137"] = '备份用户信息不存在';  //MA_BACKUP_USER_INFO_NOT_EXISTS
    errorMsg["n1138"] = '备份邮箱使用情况不存在';  //MA_BACKUP_USER_USED_INFO_NOT_EXISTS
    errorMsg["n1139"] = '嵌套列表不能是自己';  //MA_MAIL_LIST_YOURSELF
    errorMsg["n1140"] = '创建文件报错';  //MA_SYS_FILE_CREATE_ERROR
    errorMsg["n1141"] = '查询文件夹列表报错';  //MA_SYS_FILE_LIST_FOLDER_ERROR
    errorMsg["n1142"] = '查询邮件索引报错';  //MA_SYS_FILE_LIST_INDEX_ERROR
    errorMsg["n1143"] = '目录不存在';  //MA_SYS_FILE_PATH_NOT_EXIST
    errorMsg["n2001"] = '邮件不存在';  //WM_READ_MAIL_NOT_EXIST
    errorMsg["n2002"] = '非法请求或邮件链接已经过期';  //WM_READ_MAIL_NON_GARBAGE_MAIL_LINK_EXPIRED
    errorMsg["n2003"] = '此邮件已被移至收件夹，如果您是邮件客户端用户，请收取到本地查看';  //WM_READ_MAIL_NON_GARBAGE_MAIL
    errorMsg["n2004"] = '文件夹不存在';  //WM_READ_MAIL_FOLDER_NOT_EXIST
    errorMsg["n2005"] = '操作数据超过最大限制';  //WM_READ_MAX_LIMIT
    errorMsg["n2006"] = '非加密邮件';  //WM_READ_UN_ENCRYPT_MAIL_ERROR
    errorMsg["n2007"] = '加密邮件解密失败';  //WM_READ_DECRYPT_MAIL_ERROR
    errorMsg["n2008"] = '首次解密，前端未传入密码';  //WM_READ_NO_HAS_PASSWORD_ERROR
    errorMsg["n2009"] = '查询密码失败';  //WM_READ_NO_PASSWORD_ERROR
    errorMsg["n2051"] = '发信失败,请联系管理员';  //WM_SEND_MAIL_ERROR
    errorMsg["n2052"] = '参数提交异常';  //WM_SEND_MAIL_BUILD_PARAM_ERROR
    errorMsg["n2053"] = '发信地址格式错误';  //WM_SEND_MAIL_BUILD_ADDRESS_ERROR
    errorMsg["n2054"] = '发件人超容';  //WM_SEND_MAIL_OVER_SPACE_ERROR
    errorMsg["n2055"] = '发件人已被禁止发信';  //WM_SEND_MAIL_SENDER_FORBID_ERROR
    errorMsg["n2056"] = '收件人数量不能超过{count}个';  //WM_SEND_MAIL_ADDRESS_TO_MAX_LIMIT_ERROR
    errorMsg["n2057"] = '普通附件总大小超过限制';  //WM_SEND_MAIL_ATTACHMENT_MAX_LIMIT_ERROR
    errorMsg["n2058"] = 'postmaster账号被禁用';  //WM_SEND_MAIL_POSTMASTER_FORBIDDEN_ERROR
    errorMsg["n2059"] = '编辑器内图片已过期，请重新上传';  //WM_SEND_MAIL_INNER_FILE_EXPIRE
    errorMsg["n2060"] = '附件文件已过期，请重新上传';  //WM_SEND_MAIL_ATTACH_FILE_EXPIRE
    errorMsg["n2061"] = '撤回失败，请稍后重试';  //WM_SEND_UNDO_MAIL_ERROR
    errorMsg["n2062"] = '完成撤回';  //WM_SEND_UNDO_MAIL_EXECUTED_ERROR
    errorMsg["n2063"] = '发件人非本系统邮箱，不支持撤回';  //WM_SEND_UNDO_MAIL_NO_SELF_ERROR
    errorMsg["n2064"] = '撤回失败，邮件超过{undo_time_limit}或已被收件人删除';  //WM_SEND_UNDO_MAIL_EXPIRED_ERROR
    errorMsg["n2065"] = '撤回失败，群发单显加密邮件暂不支持撤回';  //WM_SEND_UNDO_MAIL_SEND_ALONE_ENCRYPT_ERROR
    errorMsg["n2201"] = '附件分片上传失败';  //WM_ATTACH_UPLOAD_FAIL
    errorMsg["n2202"] = '内嵌文件上传失败';  //WM_INNER_FILE_UPLOAD_FAIL
    errorMsg["n2203"] = '不支持的内嵌文件类型';  //WM_INNER_FILE_CONTENT_TYPE_FAIL
    errorMsg["n2204"] = '内嵌文件太大';  //WM_INNER_FILE_TOO_LARGE_FAIL
    errorMsg["n2205"] = '对不起，您下载次数过于频繁，请稍后再试';  //WM_ATTACH_DOWNLOAD_FREQUENCY_FAIL
    errorMsg["n2251"] = '最多可创建{sign_max}个邮件签名';  //WM_MAILACCOUNTSIGN_ERROR
    errorMsg["n2252"] = '内容格式有误';  //WM_MAILACCOUNTSIGN_SAVE_ERROR
    errorMsg["n2254"] = '新密码不能与原密码相同';  //WM_PASSWORD_SAME_ERROR
    errorMsg["n2256"] = '新密码过于简单，请重新输入';  //WM_PASSWORD_SIMPLE_ERROR
    errorMsg["n2257"] = '您输入的旧密码有误';  //WM_PASSWORD_INVALID_ERROR
    errorMsg["n2260"] = '新密码不符合规则';  //WM_PASSWORD_WEAK_ERROR
    errorMsg["n2301"] = '联系人已存在';  //WM_CONTACT_ADDUSER_ERROR
    errorMsg["n2302"] = '邮箱格式不符合规范';  //WM_CONTACT_EMAILFORMAT_ERROR
    errorMsg["n2303"] = '导出联系人失败';  //WM_CONTACT_EXPORTCONTACT_ERROR
    errorMsg["n2304"] = '文件格式不符合规范';  //WM_CONTACT_FILEFORMAT_ERROR
    errorMsg["n2305"] = '要导入的联系人数据为空';  //WM_CONTACT_IMPORTCONTACT_ERROR
    errorMsg["n2306"] = '组名称已存在';  //WM_CONTACT_GROUPNAME_ERROR
    errorMsg["n2307"] = '个人通讯录联系人数量不能超过{contact_max}';  //WM_CONTACT_COUNTMAX_ERROR
    errorMsg["n2308"] = '导入联系人失败';  //WM_CONTACT_IMPORT_ERROR
    errorMsg["n2309"] = '未查询到邮件列表信息';  //WM_CONTACT_GETEMAILLIST_ERROR
    errorMsg["n2310"] = '主邮箱不可重复添加';  //WM_CONTACT_EMAILREPEAT_ERROR
    errorMsg["n2340"] = '至少有一项不为空';  //WM_CONTACT_NOTNULLITEM_ERROR
    errorMsg["n2341"] = '邮件列表不存在';  //WM_CONTACT_GETSELECTORID_ERROR
    errorMsg["n2342"] = '导入文件大小超过限制';  //WM_CONTACT_FILEMAX_ERROR
    errorMsg["n2343"] = '暂不支持导入此文件类型';  //WM_CONTACT_FILETYPE_ERROR
    errorMsg["n2344"] = '邮箱最多可添加{user_contact_member_max}条';  //WM_CONTACT_EMAIL_MAX_ERROR
    errorMsg["n2345"] = '电话最多可添加{user_contact_member_max}条';  //WM_CONTACT_TELEPHONE_MAX_ERROR
    errorMsg["n2346"] = '传真最多可添加{user_contact_member_max}条';  //WM_CONTACT_FAX_MAX_ERROR
    errorMsg["n2351"] = '未查询到常规设置';  //WM_ACCOUNT_NOSETTING_ERROR
    errorMsg["n2352"] = '修改常规设置失败';  //WM_ACCOUNT_UPDATE_ERROR
    errorMsg["n2353"] = '默认抄送地址最多可添加{cc_email_max}条';  //WM_ACCOUNT_CC_MAX_ERROR
    errorMsg["n2354"] = '默认密送地址最多可添加{cc_email_max}条';  //WM_ACCOUNT_BCC_MAX_ERROR
    errorMsg["n2401"] = '黑名单最多可添加{black_list_max}条';  //WM_BLACKLIST_MAXCOUNT_ERROR
    errorMsg["n2402"] = '您添加的黑名单已经存在!';  //WM_BLACKLIST_EXICT_ERROR
    errorMsg["n2451"] = '账号信息不存在';  //WM_AUTHCODE_USERNOTEXIST_ERROR
    errorMsg["n2452"] = '授权码最多可添加{client_code_max}条';  //WM_AUTHCODE_MAXCOUNT_ERROR
    errorMsg["n2501"] = '未查询到反垃圾设置';  //WM_ANTISPAM_NODEF_ERROR
    errorMsg["n2502"] = '系统异常,请稍后重试';  //WM_ANTISPAM_SAVEREDIS_ERROR
    errorMsg["n2503"] = '时间不能为空,请设置提醒时间';  //WM_ANTISPAM_REMINDER_ERROR
    errorMsg["n2551"] = 'POP邮箱已存在，请勿重复添加';  //WM_POP_EMAILCOUNT_ERROR
    errorMsg["n2552"] = 'POP邮箱最多添加{pop_email_max}个';  //WM_POP_EMAILCOUNT_MAX_ERROR
    errorMsg["n2553"] = '邮箱格式不正确';  //WM_POP_EMAIL_FORMAT_ERROR
    errorMsg["n2554"] = 'POP邮箱账号验证失败!请检查设置';  //WM_POP_AUTH_ERROR
    errorMsg["n2555"] = '存放至文件夹不存在';  //WM_POP_FOLDER_ERROR
    errorMsg["n2556"] = 'POP邮箱账号验证失败!请检查设置';  //WM_POP_RETR_ERROR
    errorMsg["n2601"] = '邮箱格式有误，示例：name@example.com';  //WM_DELIVER_EMAIL_ERROR
    errorMsg["n2602"] = '自动转发与回复设置发禁止修改，如有问题请及时联系管理员';  //WM_DELIVER_DISABLE_ERROR
    errorMsg["n2603"] = '禁止转发到外域';  //WM_DELIVER_FOREIGN_ERROR
    errorMsg["n2604"] = '自动转发地址最多可添加{forward_addr_max}个';  //WM_DELIVER_ADDRMAX_ERROR
    errorMsg["n2605"] = '禁止添加自己的邮箱';  //WM_DELIVER_FORWARDADDR_ERROR
    errorMsg["n2651"] = '分类过滤规则最多可添加{filter_rule_max}个';  //WM_FILTER_MAXCOUNT_ERROR
    errorMsg["n2652"] = '分类过滤规则名字已存在';  //WM_FILTER_NAMESAME_ERROR
    errorMsg["n2653"] = '指定文件夹不存在';  //WM_FILTER_FOLDER_ERROR
    errorMsg["n2654"] = '发件人最多可添加{filter_member_max}个';  //WM_FILTER_FROM_MEMBER_ERROR
    errorMsg["n2655"] = '收件人最多可添加{filter_member_max}个';  //WM_FILTER_TO_MEMBER_ERROR
    errorMsg["n2701"] = '文件不存在';  //WM_LARGE_FILE_NOT_FOUND_ERROR
    errorMsg["n2751"] = '邮件审核已完成';  //WM_AUDIT_MAIL_STATUS_FINISH
    errorMsg["n2801"] = '文件夹名称长度超出限制';  //WM_FOLDER_NAME_MAX_LIMIT
    errorMsg["n2802"] = '可能存在同名文件夹';  //WM_FOLDER_UNIQ_KEY_ERROR
    errorMsg["n2851"] = '邮件日发送数量超限';  //WM_SMTP_512_1
    errorMsg["n2852"] = '发件人在收件人{invalidAddress}的黑名单中';  //WM_SMTP_512_2
    errorMsg["n2853"] = '禁止向无权限的邮件列表发信';  //WM_SMTP_513
    errorMsg["n2854"] = '发件人在{invalidAddress}黑名单中';  //WM_SMTP_515
    errorMsg["n2855"] = '域或用户被禁用';  //WM_SMTP_535
    errorMsg["n2856"] = '用户{invalidAddress}不存在';  //WM_SMTP_550_1
    errorMsg["n2857"] = '用户{invalidAddress}已锁定';  //WM_SMTP_550_2
    errorMsg["n2858"] = '禁止发送邮件';  //WM_SMTP_552
    errorMsg["n2859"] = '禁止发送到外域邮箱{invalidAddress}';  //WM_SMTP_554
    errorMsg["n2860"] = '禁止发送到指定域或用户{invalidAddress}';  //WM_SMTP_555
    errorMsg["n2861"] = '不允许发送到以下地址{invalidAddress}';  //WM_SMTP_556
    errorMsg["n2862"] = '收件人数量超限';  //WM_SMTP_557
    errorMsg["n2863"] = '{invalidAddress}禁止接收外域邮箱发来的邮件';  //WM_SMTP_558
    errorMsg["n2864"] = '邮件大小超过角色上限';  //WM_SMTP_559_1
    errorMsg["n2865"] = '邮件大小超过系统上限';  //WM_SMTP_559_2
    errorMsg["n2866"] = '用户{invalidAddress}邮箱容量超限';  //WM_SMTP_573
    errorMsg["n2867"] = '主题或内容中包含关键字，禁止发送';  //WM_SMTP_598
    errorMsg["n2868"] = '疑似钓鱼邮件，禁止发送';  //WM_SMTP_599
    errorMsg["n2869"] = 'IP并发连接数超限:{invalidAddress}';  //WM_SMTP_591
    errorMsg["n2870"] = 'IP连接频率超限:{invalidAddress}';  //WM_SMTP_592
    errorMsg["n2871"] = 'IP发信频率超限:{invalidAddress}';  //WM_SMTP_593
    errorMsg["n2872"] = 'Sender并发连接数超限:{invalidAddress}';  //WM_SMTP_594
    errorMsg["n2873"] = 'Sender发信频率超限:{invalidAddress}';  //WM_SMTP_595
    errorMsg["n2874"] = 'Rejected,ip in blacklist:{invalidAddress}';  //WM_SMTP_516
    errorMsg["n2875"] = 'Rejected,sender in blacklist: {invalidAddress}';  //WM_SMTP_517
    errorMsg["n2876"] = 'Rejected,domain in blacklist: {invalidAddress}';  //WM_SMTP_518
    errorMsg["n2877"] = 'ip in spamhaus blacklist';  //WM_SMTP_560
    errorMsg["n2901"] = '手动添加信任地最多可添加{trust_location_manual_max}个';  //WM_TRUST_LOCATION_MAX_ERROR
    errorMsg["n2902"] = '此手机号码绑定邮箱个数已达上限';  //WM_BIND_PHONE_MAX_ERROR
    errorMsg["n2903"] = '当前用户未绑定此手机号';  //WM_SAFE_LOGIN_BIND_INFO_NOT_EXSIT
    errorMsg["n3001"] = '无权限';  //UDCD_PERMISSION_DENIED
    errorMsg["n3002"] = '认证失败';  //UDCD_AUTHENTICATION_ERROR
    errorMsg["n3101"] = '用户名或密码错误';  //UDR_CORP_NOT_FOUND
    errorMsg["n3102"] = '客户已被禁用';  //UDR_CORP_FORBIDDEN
    errorMsg["n3106"] = '企业已被禁用';  //UDR_MAIL_CORP_FORBIDDEN
    errorMsg["n3107"] = '用户已被禁用';  //UDR_MAIL_ACCOUNT_FORBIDDEN
    errorMsg["n3108"] = '接口ID不存在或密钥错误';  //UDR_API_USER_NOT_FOUND
    errorMsg["n3109"] = '该应用已被禁用';  //UDR_API_USER_FORBIDDEN
    errorMsg["n3110"] = '不允许该ip登录';  //UDR_API_IP_ERROR
    errorMsg["n3111"] = '不允许Web登录';  //UDR_API_WEB_ERROR
    errorMsg["n3112"] = '刷新token不存在';  //UDR_REFRESH_TOKEN_ERROR
    errorMsg["n3113"] = '用户名或密码错误';  //UDR_USER_PASSWORD_ERROR
    errorMsg["n3114"] = '用户名密码错误次数过多，已被临时锁定，请稍后再试或联系管理员修改密码';  //UDR_USER_PASSWORD_LOCK_ERROR
    errorMsg["n3115"] = '用户首次修改密码';  //UDR_USER_PASSWORD_FIRST_ERROR
    errorMsg["n3116"] = '用户定期修改密码';  //UDR_USER_PASSWORD_CYCLE_ERROR
    errorMsg["n3117"] = '新密码过于简单，请重新输入';  //UDR_USER_PASSWORD_WEAK_ERROR
    errorMsg["n3118"] = '登录IP被限制';  //UDR_USER_IP_LIMITED_ERROR
    errorMsg["n3119"] = '登录时间被限制';  //UDR_USER_TIME_LIMITED_ERROR
    errorMsg["n3120"] = '登录成功';  //UDR_USER_LOGIN_SUCCESS
    errorMsg["n3121"] = '企业不存在';  //UDR_CORP_NOT_EXIST
    errorMsg["n3122"] = '企业已被删除';  //UDR_CORP_STATUS_ERROR
    errorMsg["n3123"] = '企业已到期';  //UDR_CORP_EXPIRE_ERROR
    errorMsg["n3124"] = '只允许ssl登录';  //UDR_API_SSL_ERROR
    errorMsg["n3125"] = '不允许POP登录';  //UDR_API_POP_ERROR
    errorMsg["n3126"] = '不允许IMAP登录';  //UDR_API_IMAP_ERROR
    errorMsg["n3127"] = '不允许SMTP登录';  //UDR_API_SMTP_ERROR
    errorMsg["n3128"] = '客户端授权码认证失败';  //UDR_USER_AUTHCODE_ERROR
    errorMsg["n3129"] = '管理员已被禁用';  //UDR_MANAGER_FORBIDDEN
    errorMsg["n3141"] = '用户名或密码错误';  //UDR_CORP_ID_NOT_FOUND
    errorMsg["n3142"] = '用户名或密码错误';  //UDR_DOMIAN_ID_NOT_FOUND
    errorMsg["n3143"] = '用户名或密码错误';  //UDR_DOMIAN_NOT_FOUND
    errorMsg["n3144"] = '用户名或密码错误';  //UDR_USER_ID_NOT_FOUND
    errorMsg["n3145"] = '用户名或密码错误';  //UDR_USER_EMAIL_NOT_FOUND
    errorMsg["n3146"] = '邮箱帐号ID不存在';  //UDR_MAIL_ACCOUNT_ID_NOT_FOUND
    errorMsg["n3147"] = '用户名或密码错误';  //UDR_MAIL_ACCOUNT_EMAIL_NOT_FOUND
    errorMsg["n3148"] = '用户名或密码错误';  //UDR_MEMBER_SELECTOR_ID_NOT_FOUND
    errorMsg["n3149"] = '用户名或密码错误';  //UDR_PWD_DECRYPT_ERROR
    errorMsg["n3150"] = '登录地区被限制';  //UDR_USER_LOCATION_LIMITED_ERROR
    errorMsg["n3151"] = '时间戳不合法';  //UDR_SSO_TIMESTAMP_ERROR
    errorMsg["n3152"] = '接口信息不存在';  //UDR_SSO_API_ERROR
    errorMsg["n3153"] = '无接口权限';  //UDR_SSO_INTERFACE_ERROR
    errorMsg["n3154"] = '签名不合法';  //UDR_SSO_SIGN_ERROR
    errorMsg["n3155"] = '企业无此接口权限';  //UDR_SSO_PARTNER_ERROR
    errorMsg["n3156"] = '获取用户信息错误';  //UDR_SSO_GETUSERINFO_ERROR
    errorMsg["n3157"] = '账号异常';  //UDR_SSO_EMAIL_ERROR
    errorMsg["n3158"] = '此邮箱已绑定';  //UDR_SSO_EMAILBIND_ERROR
    errorMsg["n3159"] = '不可绑定多个邮箱';  //UDR_SSO_BIND_ERROR
    errorMsg["n3160"] = '用户信息不合法';  //UDR_SSO_USERINFO_ERROR
    errorMsg["n3161"] = '应用配置信息不合法';  //UDR_SSO_INFO_ERROR
    errorMsg["n3162"] = '应用重定向失败';  //UDR_SSO_REDIRECT_ERROR
    errorMsg["n3163"] = '打开邮件失败，邮件收件人与绑定邮箱不一致';  //UDR_SSO_READMSG_ERROR
    errorMsg["n3164"] = '此邮箱已绑定用户';  //UDR_SSO_BINDED_ERROR
    errorMsg["n3165"] = '用户未绑定邮箱';  //UDR_SSO_BIND_RELATION_ERROR
    errorMsg["n3166"] = '用户邮箱为空';  //UDR_SSO_EVENT_EMAIL_ERROR
    errorMsg["n3167"] = '用户邮箱域名不合法';  //UDR_SSO_EVENT_EMAIL_DOMAIN
    errorMsg["n3168"] = '未查询到父级部门';  //UDR_SSO_EVENT_PARENTDEP_ERROR
    errorMsg["n3169"] = '此邮箱已存在绑定关系';  //UDR_SSO_EVENT_BIND_ERROR
    errorMsg["n3170"] = '调用ma创建用户失败';  //UDR_SSO_EVENT_USER_API_ERROR
    errorMsg["n3171"] = '未查询到部门信息';  //UDR_SSO_EVENT_DEP_ERROR
    errorMsg["n3172"] = '获取ma接口token失败';  //UDR_SSO_GETMATOKEN_ERROR
    errorMsg["n3173"] = '事件未返回部门信息';  //UDR_SSO_EVENT_FSDEP_ERROR
    errorMsg["n3174"] = '需要用户进行二次验证登录';  //UDR_SECURE_LOGIN
    errorMsg["n4001"] = '未获取到卷信息';  //FS_VOLUME_INFO_NOT_FOUND
    errorMsg["n4010"] = '未发现文件';  //FS_FILE_NOT_FOUND
    errorMsg["n4012"] = '文件ID无效';  //FS_FILE_ID_INVALID
    errorMsg["n4013"] = '文件状态无效';  //FS_FILE_STATUS_INVALID
    errorMsg["n4014"] = '';  //FS_FILE_MIME_NOT_FOUND
    errorMsg["n4021"] = '您查看的邮件已不存在';  //FS_FILE_GET_FAIL
    errorMsg["n4023"] = '获取文件指定偏移量及长度无效';  //FS_FILE_GET_INVALID_POS_SIZE
    errorMsg["n4031"] = '保存文件失败';  //FS_FILE_SAVE_FAIL
    errorMsg["n4032"] = '保存文件已经存在';  //FS_FILE_SAVE_EXIST
    errorMsg["n4033"] = '文件上传失败';  //FS_FILE_UPLOAD_FAIL
    errorMsg["n4034"] = '文件上传分片校验失败';  //FS_FILE_UPLOAD_CHUNK_CHECK_FAIL
    errorMsg["n4037"] = '对不起，您访问的链接已经过期或者失效!';  //FS_FILE_DOWNLOAD_FAIL
    errorMsg["n4039"] = '删除文件失败';  //FS_FILE_DEL_FAIL
    errorMsg["n4041"] = '存储文件没有发现头信息';  //FS_FILE_HEAD_NOT_FOUND
    errorMsg["n4042"] = '存储文件头信息无效';  //FS_FILE_HEAD_INVALID
    errorMsg["n4053"] = '存储文件分片长度无效';  //FS_FILE_CHUNK_SIZE_INVALID
    errorMsg["n4062"] = '邮箱帐号文件ID无效';  //FS_MAIL_ACCOUNT_FILE_ID_INVALID
    errorMsg["n4063"] = '邮箱帐号文件状态无效';  //FS_MAIL_ACCOUNT_FILE_STATUS_INVALID
    errorMsg["n4101"] = '获取信头失败';  //MS_GET_MAIL_HEADER
    errorMsg["n4102"] = '企业无效';  //MS_CORP_INVALID
    errorMsg["n4103"] = '企业ID无效';  //MS_CORP_ID_INVALID
    errorMsg["n4104"] = '企业存在';  //MS_CORP_EXIST
    errorMsg["n4105"] = '邮箱帐号无效';  //MS_MAIL_ACCOUNT_INVALID
    errorMsg["n4106"] = '邮箱帐号ID无效';  //MS_MAIL_ACCOUNT_ID_INVALID
    errorMsg["n4107"] = '邮箱帐号存在';  //MS_MAIL_ACCOUNT_EXIST
    errorMsg["n4111"] = '文件夹无效';  //MS_FOLDER_INVALID
    errorMsg["n4112"] = '文件夹ID无效';  //MS_FOLDER_ID_INVALID
    errorMsg["n4113"] = '存在同名文件夹';  //MS_FOLDER_EXIST
    errorMsg["n4114"] = '文件夹不存在';  //MS_FOLDER_NOT_EXIST
    errorMsg["n4115"] = '无效的父文件夹';  //MS_FOLDER_INVALID_PARENT
    errorMsg["n4116"] = '文件夹空间占用标记不一致';  //MS_FOLDER_DATA_INVALID
    errorMsg["n4121"] = '文件夹层级超限';  //MS_FOLDER_DEPTH_MAX_LIMIT
    errorMsg["n4122"] = '文件夹数量超限';  //MS_FOLDER_COUNT_MAX_LIMIT
    errorMsg["n4131"] = '不能修改系统文件夹';  //MS_FOLDER_DENY_CHANGE_SYS_FOLDER
    errorMsg["n4132"] = '不能在已备份文件夹中创建文件夹';  //MS_FOLDER_BACKUP_CREATE_SUBFOLDER
    errorMsg["n4133"] = '不能删除系统文件夹';  //MS_FOLDER_DENY_DEL_SYS_FOLDER
    errorMsg["n4134"] = '文件夹内存在邮件， 故不能删除';  //MS_FOLDER_DENY_DEL_MAIL_EXIST
    errorMsg["n4135"] = '文件夹存在子文件夹，故不能删除';  //MS_FOLDER_DENY_DEL_SUBFOLDER_EXISTED
    errorMsg["n4201"] = '邮件索引处理失败';  //MS_INDEX_PROC_FAIL
    errorMsg["n4202"] = '邮件索引无效';  //MS_INDEX_INVALID
    errorMsg["n4203"] = '邮件索引ID无效';  //MS_INDEX_ID_INVALID
    errorMsg["n4204"] = '邮件索引未发现';  //MS_INDEX_NOT_FOUND
    errorMsg["n4221"] = '邮箱容量超限';  //MS_INDEX_OVER_SPACE_LIMIT
    errorMsg["n4222"] = '用户邮箱封数超容';  //MS_INDEX_OVER_NUM_LIMIT
    errorMsg["n4231"] = '密码验证失败';  //MS_INDEX_VERIFY_PASSWORD_FAIL
    errorMsg["n5001"] = '短信发送失败';  //NOTIFIER_SMS_SEND_FAIL
    errorMsg["n5002"] = '短信模板不存在';  //NOTIFIER_SMS_TEMPLATE_NOT_FOUND
    errorMsg["n5003"] = '验证码无效或已过期';  //NOTIFIER_CODE_ERROR
    errorMsg["n5004"] = '验证码不能为空';  //NOTIFIER_CAN_NOT_NULL
    errorMsg["n5005"] = '获取验证码过于频繁';  //NOTIFIER_CODE_LIMIT_ERROR
    errorMsg["n5006"] = '短信通道拥堵，请稍后再试！';  //NOTIFIER_MD_SERVER_ERROR
    errorMsg["n5007"] = '漫道发送短信失败';  //NOTIFIER_MD_SEND_ERROR
    errorMsg["n5008"] = '当日获取验证码次数已达上限';  //NOTIFIER_CODE_DAY_LIMIT_ERROR
    errorMsg["n6001"] = '调用ms失败';  //SCHEDULE_FEIGN_MS_FAIL
    errorMsg["n7001"] = '组装消息内容失败';  //PUSH_MESSAGE_BUILDMSG_ERROR
    errorMsg["n8001"] = '文件转换失败';  //ATTACH_TRANSFER_FILE_ERROR
    errorMsg["n9001"] = '系统配置信息异常';  //SYSTEM_CONFIG_INFO_ERROR
    errorMsg["n9100"] = '未查询到有效的许可证文件';  //LICENSE_JSON_DEVICE_INFO
    errorMsg["n9101"] = '未查询到有效的许可证文件';  //LICENSE_JSON_LICENSE
    errorMsg["n9102"] = '未查询到有效的许可证文件';  //LICENSE_JSON_BOSS_CONTRACTS
    errorMsg["n9103"] = '未查询到有效的许可证文件';  //LICENSE_JSON_DEVICE_INFOS
    errorMsg["n9104"] = '未查询到有效的许可证文件';  //LICENSE_JSON_UPDATE
    errorMsg["n9105"] = '未查询到有效的许可证文件';  //LICENSE_JSON_LICENSE_INCOMPLETE
    errorMsg["n9120"] = '未查询到有效的许可证文件';  //LICENSE_RSA_PRI_NULL
    errorMsg["n9121"] = '未查询到有效的许可证文件';  //LICENSE_RSA_PUB_NULL
    errorMsg["n9122"] = '未查询到有效的许可证文件';  //LICENSE_RSA_PUBLIC_ENCRYPT
    errorMsg["n9123"] = '未查询到有效的许可证文件';  //LICENSE_RSA_PUBLIC_DECRYPT
    errorMsg["n9124"] = '未查询到有效的许可证文件';  //LICENSE_RSA_PRIVATE_ENCRYPT
    errorMsg["n9125"] = '未查询到有效的许可证文件';  //LICENSE_RSA_PRIVATE_DECRYPT
    errorMsg["n9130"] = '未查询到有效的许可证文件';  //LICENSE_AES_KEY
    errorMsg["n9140"] = '未查询到有效的许可证文件';  //LICENSE_PACK_START_END_LINE
    errorMsg["n9141"] = '未查询到有效的许可证文件';  //LICENSE_PACK_DATA_SIZE
    errorMsg["n9142"] = '未查询到有效的许可证文件';  //LICENSE_PACK_DATA_SIZE_RSA
    errorMsg["n9143"] = '未查询到有效的许可证文件';  //LICENSE_PACK_DATA_FALSIFIED
    errorMsg["n9150"] = '未查询到有效的许可证文件';  //LICENSE_DEVICE_INFOS_DATA_SIZE
    errorMsg["n9151"] = '未查询到有效的许可证文件';  //LICENSE_DEVICE_ID_DISMATCH
    errorMsg["n9152"] = '未查询到有效的许可证文件';  //LICENSE_DEVICE_INFO_INCOMPLETE
    errorMsg["n9153"] = '未查询到有效的许可证文件';  //LICENSE_DEVICE_INFOS_EMPTY
    errorMsg["n9154"] = '未查询到有效的许可证文件';  //LICENSE_DEVICE_GET_INFO
    errorMsg["n9160"] = '未查询到有效的许可证文件';  //LICENSE_TIME_UPDATE
    errorMsg["n9161"] = '未查询到有效的许可证文件';  //LICENSE_TIME_PURCHASE
    errorMsg["n9162"] = '未查询到有效的许可证文件';  //LICENSE_TIME_EXPIRY
    errorMsg["n9163"] = '未查询到有效的许可证文件';  //LICENSE_TIME_NULL
    errorMsg["n9164"] = '未查询到有效的许可证文件';  //LICENSE_TIME_EXPIRED
    errorMsg["n9170"] = '未查询到有效的许可证文件';  //LICENSE_REDIS_HOST_STR
    errorMsg["n9171"] = '未查询到有效的许可证文件';  //LICENSE_REDIS_HSET
    errorMsg["n9172"] = '未查询到有效的许可证文件';  //LICENSE_REDIS_HGET
    errorMsg["n9180"] = '许可证导入失败';  //LICENSE_IMPORT_ERROR
    errorMsg["n9199"] = '许可证失败';  //LICENSE_UNKNOWN_ERROR
    errorMsg["n9200"] = '认证失败';  //UMT_AUTH_ERR
    errorMsg["n9201"] = '参数失败';  //UMT_PARAMETER_ERR
    errorMsg["n9203"] = 'acl异常';  //UMT_ACL_ERR
    errorMsg["n9204"] = '查询文件夹失败';  //UMT_LIST_FOLDER_ERR
    errorMsg["n9205"] = '添加文件夹异常';  //UMT_ADD_FOLDER_ERR
    errorMsg["n9206"] = 'ms存信异常';  //UMT_SAVE_EMAIL_ERR
    errorMsg["n9207"] = 'imap异常';  //UMT_IMAP_ERR
    errorMsg["n9217"] = 'pop异常';  //UMT_POP_ERR
    errorMsg["n9299"] = '搬家异常';  //UMT_UNKNOWN_ERROR
    errorMsg["n9300"] = '系统异常';  //MIDS_SYSTEM_ERROR
    errorMsg["n9301"] = 'IP in blacklist:{ip}';  //MIDS_IP_BLACKLIST
    errorMsg["n9302"] = 'IP locked:{ip}';  //MIDS_IP_PRISON
    errorMsg["n9303"] = 'User locked:{email}';  //MIDS_ACCOUNT_PRISON
    errorMsg["n-100"] = '参数错误';  //MIGRATE_ERROR_PARAMERROR
    errorMsg["n-101"] = '测试账号验证失败，请检查服务器信息和测试账号及密码';  //MIGRATE_ERROR_PASSWDERROR
    errorMsg["n-102"] = '网络错误';  //MIGRATE_ERR_OR_NETERROR
    errorMsg["n9999"] = '功能尚未支持，敬请期待!';  //UN_SUPPORT
    errorMsg["n10000"] = 'last error';  //LAST_ERROR

    return function (errorCode) {
        let code = errorCode;
        let msgVals = undefined;
        if ('object' === typeof errorCode) {
            code = errorCode.code;
            msgVals = errorCode.msgVals;
        }

        let msg = errorMsg["n" + code];
        if (typeof msg === "undefined") {
            msg = errorMsg["n1000"];
        }

        if ('object' === typeof msgVals) {
            for (let key in msgVals) {
                if (key === 'undo_time_limit') {
                    let num_unit = parseInt(msgVals[key]) < 24 ? parseInt(msgVals[key]) + '小时' : parseInt(msgVals[key]) / 24 + '天';
                    msg = msg.replace(new RegExp('\\{' + key + '\\}', 'g'), num_unit);
                } else {
                    msg = msg.replace(new RegExp('\\{' + key + '\\}', 'g'), msgVals[key])
                }
            }
        }

        return msg;
    }

})();

export default getErrorMsg;



// WEBPACK FOOTER //
// ./src/language/cnErrorMessage.js